import { Fragment, useRef } from "react"
import {
  LoadingContainer,
  PreviewImage,
  RemoveImageWrapper,
  UploadTitle,
  Wrapper,
} from "./styled"
import UploadIcon from "./UploadIcon"
import { SpinLoading } from "antd-mobile"
import HiddenImageInput from "./HiddenImageInput"
import { useImageUploader } from "features/image/hooks"
import imageUploaderPlaceholder from "assets/images/image-uploader-placeholder.png"
import styled from "styled-components"
import { FlexBox } from "components/Common/FlexBox"

const ImagePlaceholderBox = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  width: 100%;
  height: 100%;
`

export const ImagePlaceholder = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const ImagePlaceholderOverlay = styled.div`
  background: linear-gradient(
    180deg,
    rgba(28, 31, 33, 0.1) 16.67%,
    rgba(28, 31, 33, 0.64) 75.52%
  );
  position: absolute;
  width: 100%;
  height: 100%;
`

const RemoveImageButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <RemoveImageWrapper>
      <svg
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onClick()
        }}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g opacity="0.85">
          <g clipPath="url(#clip0_3389_17635)">
            <path
              d="M0 0H17C20.866 0 24 3.13401 24 7V24H8C3.58172 24 0 20.4183 0 16V0Z"
              fill="#1C1F21"
            />
            <path
              d="M18.6894 5.3212C18.2753 4.90709 17.6064 4.90709 17.1923 5.3212L12 10.5028L6.80774 5.31058C6.39363 4.89647 5.72469 4.89647 5.31058 5.31058C4.89647 5.72469 4.89647 6.39363 5.31058 6.80774L10.5028 12L5.31058 17.1923C4.89647 17.6064 4.89647 18.2753 5.31058 18.6894C5.72469 19.1035 6.39363 19.1035 6.80774 18.6894L12 13.4972L17.1923 18.6894C17.6064 19.1035 18.2753 19.1035 18.6894 18.6894C19.1035 18.2753 19.1035 17.6064 18.6894 17.1923L13.4972 12L18.6894 6.80774C19.0929 6.40425 19.0929 5.72469 18.6894 5.3212Z"
              fill="#EBEDF0"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_3389_17635">
            <path
              d="M0 0H17C20.866 0 24 3.13401 24 7V24H8C3.58172 24 0 20.4183 0 16V0Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </RemoveImageWrapper>
  )
}

const ImageUploader = ({ onRemoveImage }: { onRemoveImage?: () => void }) => {
  const uploadRef = useRef<HTMLInputElement>(null)
  const {
    onImageChange,
    displayImageUrl,
    onRemoveUploadedImage,
    processImageLoading,
  } = useImageUploader()

  return (
    <Wrapper
      $disabled={processImageLoading}
      onClick={() => {
        if (!processImageLoading) {
          uploadRef.current?.click()
        }
      }}
    >
      {!displayImageUrl && (
        <FlexBox
          style={{ zIndex: 10 }}
          $direction="column"
          $alignItems="center"
        >
          <UploadIcon />
          <UploadTitle>Upload Image</UploadTitle>
        </FlexBox>
      )}

      {processImageLoading && (
        <LoadingContainer>
          <SpinLoading color="currentColor" />
        </LoadingContainer>
      )}

      {displayImageUrl ? (
        <Fragment>
          <PreviewImage src={displayImageUrl} />
          <RemoveImageButton
            onClick={() => {
              onRemoveUploadedImage()
              onRemoveImage?.()
            }}
          />
        </Fragment>
      ) : (
        <ImagePlaceholderBox>
          <ImagePlaceholderOverlay />
          <ImagePlaceholder src={imageUploaderPlaceholder} />
        </ImagePlaceholderBox>
      )}

      <HiddenImageInput
        ref={uploadRef}
        onChange={(image?: File) => {
          onImageChange(image)
        }}
      />
    </Wrapper>
  )
}

export default ImageUploader
